import { set } from '../../../utils/vuex'

export default {
  setError: set('error'),
  setAuthenticationPending: set('authenticationPending'),
  setLoading: set('loading'),
  setResetPasswordSent: set('resetPasswordSent'),
  setRole: set('role')
}
